export default {
    byProgrammeArea(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('programmeAreaId', id).get()
            )
        )
    }
}
